<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-md rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-xl font-bold text-accent">
          Link erstellt
        </h2>
        <div class="mb-6">
          <p class="mb-3 text-sm text-text-main">Jeder mit diesem Link kann das Projekt ansehen:</p>
          <input
            type="text"
            data-testid="shared-link-url"
            :value="url"
            readonly
            class="w-full rounded-standard border border-tertiary bg-primary px-3 py-2 text-sm text-text-main outline-none focus:border-accent"
            @focus="$event.target.select()"
          />
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="flex items-center gap-2 rounded-standard bg-accent px-6 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="emit('copy')"
          >
            <MdiIcon :path="mdiContentCopy" size="16" />
            Link kopieren
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { mdiContentCopy } from '@mdi/js'
import MdiIcon from '@/components/MdiIcon.vue'

defineProps<{
  isOpen: boolean
  url: string
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'copy'): void
}>()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
